<template>
  <div
    class="
      container-status-detail-view
      flex
      justify-start
      col-gap-10
      flex-wrap
      pb-3
    "
  >
    <div class="vessel-name aisea-text-24-400-black truncate">
      {{ enerpriseVesselName }}
    </div>
    <!-- コンテナ数 -->
    <div
      class="status-count container-count flex gap-1 items-center flex-shrink-0"
    >
      <span class="aisea-text-14-300-black"> コンテナ数 </span>
      <span class="aisea-text-20-400-black">
        {{ counts.container_count }}
      </span>
    </div>
    <!-- 正常 -->
    <div
      class="status-count active-count flex gap-1 items-center flex-shrink-0"
    >
      <div class="color-chip active" />
      <span class="aisea-text-14-300-black"> 正常 </span>
      <span class="aisea-text-20-400-black">
        {{ counts.active_count }}
      </span>
    </div>
    <div class="status-count alert-count flex gap-1 items-center flex-shrink-0">
      <!-- 異常 -->
      <div class="color-chip alert" />
      <span class="aisea-text-14-300-black"> 異常 </span>
      <span class="aisea-text-20-400-black">
        {{ counts.alert_count }}
      </span>
    </div>
    <div
      class="status-count power-off-count flex gap-1 items-center flex-shrink-0"
    >
      <div class="color-chip power-off" />
      <!-- 非稼働 -->
      <span class="aisea-text-14-300-black"> 非稼働 </span>
      <span class="aisea-text-20-400-black">
        {{ counts.power_off_count }}
      </span>
    </div>
    <!-- 監視休止 -->
    <div
      class="status-count interlock-count flex gap-1 items-center flex-shrink-0"
    >
      <div class="color-chip interlock" />
      <span class="aisea-text-14-300-black"> 監視休止 </span>
      <span class="aisea-text-20-400-black">
        {{ counts.interlock_count }}
      </span>
    </div>
    <div
      class="
        last-updated-at-wrapper
        cell
        flex flex-no-wrap flex-shrink-0
        items-center
        gap-1
        mr-auto
      "
    >
      <div
        class="
          last-updated-at
          flex flex-no-wrap flex-shrink-0
          items-center
          gap-1
        "
      >
        <vs-icon icon="schedule" size="15px"></vs-icon>
        <span class="aisea-text-14-300-black flex-shrink-0">
          {{ lastUpdatedAt }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContainerStatusCountDetailView",
  props: {
    counts: {
      container_count: { type: Number },
      active_count: { type: Number },
      alert_count: { type: Number },
      interlock_count: { type: Number },
      power_off_count: { type: Number },
    },
    lastUpdatedAt: { type: String, default: "" },
    enerpriseVesselName: { type: String, default: "" },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.container-status-detail-view {
  &::after,
  &::before {
    content: "";
    width: 100%;
    order: 0;
    @media screen and (min-width: $max-width-ipad-pro-12) {
      content: unset;
      width: 0;
      order: 0;
    }
  }
  .status-count {
    position: relative;
    flex-basis: 100px;
    @media screen and (min-width: $max-width-iphone-8) {
      flex-basis: fit-content;
      :last-child {
        position: relative;
        &::after {
          content: "|";
          font-family: feather !important;
          color: $aisea-mouse-gray;
          font-variant: normal;
          position: absolute;
          right: -1.25rem;
        }
      }
    }

    &.container-count {
    }

    @media screen and (min-width: $max-width-iphone-11-pro) {
      &.container-count {
        display: flex;
      }
    }
  }
  .color-chip {
    min-width: 15px;
    max-width: 15px;
    height: 15px;
    border-radius: 15px;
    margin-right: 0.2rem;
  }
  .active {
    background-color: $aisea-green;
    border: solid 2px lighten($aisea-green, 20%);
  }
  .alert {
    background-color: $aisea-pink;
    border: solid 2px lighten($aisea-pink, 10%);
  }
  .interlock {
    background-color: $aisea-mouse-gray;
    border: 2px solid rgba($aisea-mouse-gray, 0.5);
    background-clip: padding-box;
  }
  .power-off {
    background-color: $aisea-light-gray;
    border: 2px solid $aisea-mouse-gray;
  }
  .vessel-name {
    max-width: 47%;
  }
  .container-count {
  }
  .active-count {
    order: 1;
  }
  .alert-count {
    order: 1;
  }
  .power-off-count {
    order: 1;
  }
  .interlock-count {
    order: 1;
  }
  .last-updated-at-wrapper {
    order: 1;
    .last-updated-at {
      margin-top: 0.4rem;
      margin-bottom: 0.4rem;
      background: #f2f2f2;
      border-radius: 20px;
      padding: 2px 7px;
      width: 150px;
    }
    @media screen and (min-width: $max-width-iphone-8) {
    }
  }
  @media screen and (min-width: $max-width-iphone-8) {
    .vessel-name {
      order: -3;
    }
    .container-count {
      order: -2;
      > span::after {
      }
    }
    .last-updated-at-wrapper {
      order: -1;
    }
  }
  @media screen and (min-width: $max-width-iphone-11-pro) {
    .container-count {
      order: 1;
    }
    .last-updated-at-wrapper {
      order: -2;
    }
  }
  @media screen and (min-width: 1080px) {
    .last-updated-at-wrapper {
      order: 1;
      width: initial;
      margin-left: auto;
      margin-right: 0;
    }
  }
  @media screen and (min-width: $max-width-ipad-pro-12) {
    // display: none;
    .vessel-name {
      width: fit-content;
      max-width: 35%;
    }
    &::after,
    &::before {
      content: unset;
      width: 0;
      order: 0;
    }
  }
}
</style>